(() => {
  const matcher = window.PremierSearch;
  const config = document.getElementById('premier-native-config');
  if (!matcher || !config) return;
  const labels = JSON.parse(config.textContent);
  const currentURL = new URL(location.href);
  if (currentURL.pathname.replace(/\/$/,'') === '/pages/search-results-page') {
    const destination = new URL(labels.search_url,location.origin);
    for (const [key,value] of currentURL.searchParams) destination.searchParams.set(key,value);
    destination.searchParams.set('type','product');
    location.replace(destination.pathname + destination.search);
    return;
  }
  const stockOnly = currentURL.searchParams.get('filter.v.availability') === '1';
  document.querySelectorAll('[data-premier-controls]').forEach(form => {
    form.querySelector('[name="filter.v.availability"]').checked = stockOnly;
    form.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(location.href);
      ['page','filter.v.availability','filter.v.price.gte','filter.v.price.lte','sort_by'].forEach(key => url.searchParams.delete(key));
      for (const [key,value] of new FormData(form)) if (value !== '') url.searchParams.set(key,value);
      location.assign(url.pathname + url.search);
    });
    form.querySelector('[data-premier-clear]').addEventListener('click', () => {
      const url = new URL(location.href);
      Array.from(url.searchParams.keys()).forEach(key => { if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key); });
      location.assign(url.pathname + url.search);
    });
  });

  document.querySelectorAll('[data-premier-discovery]').forEach(root => {
    const grid = root.querySelector('[data-premier-grid]');
    if (!grid || root.dataset.performed === 'false') return;
    const query = root.dataset.mode === 'search' ? currentURL.searchParams.get('q') || '' : '';
    const plan = matcher.analyze(query);
    const lookupURL = new URL(currentURL);
    const rewritten = root.dataset.mode === 'search' && plan.searchQuery !== query;
    if (rewritten) lookupURL.searchParams.set('q',plan.searchQuery);
    const size = Number(grid.dataset.pageSize) || 12;
    const originalPage = Number(grid.dataset.page) || 1;
    const original = grid.innerHTML;
    const state = { items:[], seen:new Set(), next:1, pages:Number(grid.dataset.pages), shown:0, busy:false, failed:false, exact:false, bootstrap:rewritten };
    const actions = document.createElement('div');
    actions.className = 'premier-result-actions';
    const status = document.createElement('p'); status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
    const more = document.createElement('button'); more.type = 'button'; more.className = 'btn';
    actions.append(status,more); grid.after(actions);
    root.querySelectorAll('.pagination,[data-native-empty]').forEach(element => element.hidden = true);
    function collect(source) {
      Array.from(source.children).forEach(element => {
        let result = {match:false};
        if (element.hasAttribute('data-premier-id')) result = matcher.prepareCard(element,plan,stockOnly);
        if (result.exactSku) state.exact = true;
        const key = element.dataset.premierId || element.querySelector('a')?.getAttribute('href');
        if (!result.match || !key || state.seen.has(key)) return;
        state.seen.add(key); state.items.push(element);
      });
    }
    if (!rewritten && originalPage === 1) { collect(grid); state.next = 2; }
    grid.replaceChildren();
    function render(target) {
      const items = plan.sku && state.exact ? state.items.filter(item => item.dataset.premierExactSku === 'true') : plan.fullSku && state.busy && state.next <= state.pages ? [] : state.items;
      state.shown = Math.min(target,items.length);
      grid.replaceChildren(...items.slice(0,state.shown));
      const complete = state.next > state.pages;
      const count = complete ? items.length : state.shown;
      const countText = complete && count === 1 ? labels.one : labels[complete?'total':'shown'].replace('__COUNT__',count);
      root.querySelectorAll('[data-premier-count]').forEach(node => node.textContent = countText);
      if (root.dataset.mode === 'search' && query) {
        const storeName = document.title.split(' – ').pop();
        document.title = countText + ' — ' + query + ' – ' + storeName;
      }
      status.textContent = state.failed ? labels.error : state.busy ? labels.loading : state.shown ? '' : labels.empty;
      more.textContent = state.failed ? labels.retry : labels.more;
      more.hidden = state.busy || (!state.failed && complete && state.shown >= items.length);
      more.disabled = state.busy;
      grid.setAttribute('aria-busy',String(state.busy));
    }
    async function page(number) {
      if (!rewritten && number === originalPage) { const holder=document.createElement('div'); holder.innerHTML=original; return holder; }
      const url = new URL(lookupURL); url.searchParams.set('section_id',grid.dataset.section); url.searchParams.set('page',number);
      const response = await fetch(url);
      if (!response.ok) throw new Error('Unable to load results');
      const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
      const result = parsed.querySelector('[data-premier-grid]');
      if (!result) throw new Error('Results unavailable');
      return result;
    }
    async function load(target) {
      if (state.busy) return;
      state.busy=true; state.failed=false; render(target); let fetched=0;
      try {
        if (state.bootstrap) { const first=await page(1); state.pages=Number(first.dataset.pages); collect(first); state.next=2; state.bootstrap=false; }
        while(state.next<=state.pages && (plan.sku || state.items.length<target || state.pages<=8) && (plan.sku || fetched<12 || state.items.length===0)) {
          const batch=Array.from({length:Math.min(4,state.pages-state.next+1)},(_,i)=>state.next+i);
          const results=await Promise.all(batch.map(page)); results.forEach(collect); state.next+=batch.length; fetched+=batch.length; render(target);
        }
      } catch (_) { state.failed=true; }
      state.busy=false; render(target);
    }
    more.addEventListener('click',()=>load(state.failed?Math.max(size,state.shown):state.shown+size));
    load(size);
  });

  const inputs = new WeakMap(); let index=0;
  function inputState(input) {
    if(inputs.has(input)) return inputs.get(input);
    const parent=input.parentElement;
    parent.style.position='relative';
    const popup=document.createElement('div'); popup.className='premier-predictive'; popup.hidden=true; popup.id='premier-predictive-'+(++index);
    parent.append(popup);
    input.setAttribute('role','combobox'); input.setAttribute('aria-autocomplete','list'); input.setAttribute('aria-controls',popup.id); input.setAttribute('aria-expanded','false'); input.autocomplete='off';
    if(!input.getAttribute('aria-label')) input.setAttribute('aria-label',labels.search);
    const state={popup,timer:null,controller:null}; inputs.set(input,state);
    popup.addEventListener('keydown',event=>{
      if(event.key==='Escape') {popup.hidden=true;input.setAttribute('aria-expanded','false');input.focus();}
      const links=Array.from(popup.querySelectorAll('a')); const position=links.indexOf(document.activeElement);
      if(event.key==='ArrowDown'||event.key==='ArrowUp') {event.preventDefault();links[(position+(event.key==='ArrowDown'?1:-1)+links.length)%links.length]?.focus();}
    });
    return state;
  }
  document.addEventListener('input',event=>{
    const input=event.target;
    if(!input.matches('input[name="q"]:not([type="hidden"])')) return;
    const state=inputState(input); clearTimeout(state.timer); state.controller?.abort();
    const query=input.value.trim();
    if(!query) {state.popup.hidden=true;input.setAttribute('aria-expanded','false');return;}
    state.timer=setTimeout(async()=>{
      const controller=new AbortController(); state.controller=controller;
      const plan=matcher.analyze(query); const url=new URL(labels.predictive_url,location.origin);
      url.searchParams.set('q',plan.searchQuery);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','10');url.searchParams.set('section_id','premier-predictive-search');
      try {
        const response=await fetch(url,{signal:controller.signal});if(!response.ok) return;
        const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
        const holder=parsed.querySelector('#shopify-section-premier-predictive-search');if(!holder||input.value.trim()!==query) return;
        const results=Array.from(holder.querySelectorAll('[data-premier-id]')).map(card=>({card,result:matcher.prepareCard(card,plan)}));
        const exact=results.some(item=>item.result.exactSku);
        results.forEach(({card,result})=>{if(!result.match||(exact&&!result.exactSku))card.remove();});
        holder.querySelector('[data-premier-empty]').hidden=!!holder.querySelector('[data-premier-id]');
        state.popup.innerHTML=holder.innerHTML;state.popup.dataset.query=query;state.popup.hidden=false;input.setAttribute('aria-expanded','true');
      } catch(_) {}
    },300);
  });
  document.addEventListener('keydown',event=>{
    const state=inputs.get(event.target);if(!state)return;
    if(event.key==='Escape'){state.popup.hidden=true;event.target.setAttribute('aria-expanded','false');}
    if(event.key==='ArrowDown'&&!state.popup.hidden){event.preventDefault();state.popup.querySelector('a')?.focus();}
  });
  document.addEventListener('pointerdown',event=>document.querySelectorAll('.premier-predictive').forEach(popup=>{if(!popup.parentElement.contains(event.target))popup.hidden=true;}));
})();
